import { render, staticRenderFns } from "./ExportsModal.vue?vue&type=template&id=5649331c&scoped=true&"
import script from "./ExportsModal.vue?vue&type=script&lang=js&"
export * from "./ExportsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649331c",
  null
  
)

export default component.exports